class Accordion {
  constructor(header, content) {
    this.header = header;
    this.content = content;

    console.log(header);

    this.header.addEventListener("click", () => {
      this.toggle();
    });
  }

  toggle() {
    const isActive = this.header.parentNode.classList.contains("active");
    const accordions = document.querySelectorAll(".accordion");

    accordions.forEach((item) => {
      item.classList.remove("active");
    });

    if (!isActive) {
      this.header.parentNode.classList.add("active");
    }
  }
}

